import React from "react";
import Star from "assets/images/svg/rate_s.svg";
import { FavIcon } from "components/favIcon";
import ServerImage from "components/server-image/server-image";

import { json, showDiscriminate } from "helpers/data";
import { delete_Addons_wishList, delete_app_wishList } from "services/wishListServices";
import { useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { t } from "i18next";
import { ColoredLabel } from "components/classes";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CanLoadGuard from "components/private-route/can-load.guard";

const WishListCard = ({ id, title, logo, info, application, Label, content, price, rate, itemId }) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation("browse-apps");

  const handleFav = () => {
    if (application) {
      delete_app_wishList(itemId).then(() => {
        queryClient.invalidateQueries(["apps-wishList"]);
        toast.success(t("common:form.removed"));
      });
    } else {
      delete_Addons_wishList(itemId).then(() => {
        queryClient.invalidateQueries(["addons-wishList"]);
        toast.success(t("common:form.removed"));
      });
    }
  };
  console.log(rate)
  return (
    <div className="wishListCard">
      <CanLoadGuard>
        <button className="fav" onClick={handleFav}>
          <FavIcon color={true} />
        </button>
      </CanLoadGuard>
      <Link to={application ? `/app/${itemId}` : `/addon-details/${itemId}`} className="card-link">
        <ServerImage className={"logo"} src={logo} />
        <h1 className="title">{json(title)}</h1>
        <span className="info">{json(info)}</span>
        <div className="especial">
          {Label && <ColoredLabel color={Label.color}>{json(Label.name)}</ColoredLabel>}

          <div className="rate">
            <span className="number">{rate?.averageRate?.toFixed(0) ?? ''}</span>
            {rate?.averageRate? <img src={Star} alt="star" /> :''}
            <span className="count">{rate?.count ? (rate?.count) : ''}</span>
          </div>
        </div>
        <p className="content">{json(content)}</p>
        {price && (
          <span className="price">
            {t("filterBox.from")}
            <span>
              {price?.netPrice} {json(`${price?.currencySymbol}`)} / {json(`${showDiscriminate(`${price?.discrimination}`)}`)}
            </span>{" "}
          </span>
        )}
      </Link>
    </div>
  );
};

export default WishListCard;
